module.exports = __webpack_public_path__ + "img/thermometer-cold.111377e4.svg";